import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import Datetime from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import Fragment from 'vue-fragment'


import store from './store/store'
import axios from './axios'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import Paginate from "vuejs-paginate";

Vue.use(VuejsDialog)
Vue.component("Paginate", Paginate)

window._ = require('lodash')


window._n = function (number, tofixed = 2) {
  let splitNum;
  number = Math.abs(number);
  number = number.toFixed(tofixed);
  splitNum = number.split('.');
  splitNum[0] = splitNum[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return splitNum.join(".");
}

Vue.use(Fragment.Plugin)
Vue.use(Datetime)


//v-positive-numbers-only
Vue.directive('positive-numbers-only', {
  update(el, binding, vnode) {
    let model = _.find(vnode.data.directives, d => {
      return d.name === 'model'
    })
    if (model.oldValue !== model.value && 0 > model.value) {
      vnode.context[model.expression] = Math.abs(model.value)
    }
  }
})

store.dispatch('auth/tryToLoginFromLocal').then(() => {
  start()
}).catch(() => {
  start()
})

function start() {
  const app = new Vue({
    el: '#app',
    router,
    store,

    methods: {
      mnwp(number) {
        if (number < 0) {
          return '-&pound;' + _n(Math.abs(number))
        }
        return '&pound;' + _n(number)
      }
    },

    render: h => h(App)
  })
}



// WEBPACK FOOTER //
// ./src/main.js